module.exports = __webpack_public_path__ + "img/1.708af10d.jpg";